// =========================================
// auth.js — router dell'autenticazione
// =========================================
//
// Seleziona il backend auth in base alla config Firebase:
//   • Firebase configurato (client + chiavi/emulatori) → auth.firebase.js
//   • altrimenti (default, SSR, dev senza chiavi)       → auth.local.js
//
// Entrambi espongono la stessa superficie (getCurrentUser, onAuthChange,
// registerUser, loginUser, …) così le pagine auth non cambiano.

import { firebaseEnabled } from '../firebase/config';
import * as local from './auth.local';
import * as firebase from './auth.firebase';

const impl = firebaseEnabled() ? firebase : local;

export const getCurrentUser             = impl.getCurrentUser;
export const authPending                = impl.authPending;
export const onAuthChange               = impl.onAuthChange;
export const registerUser               = impl.registerUser;
export const loginUser                  = impl.loginUser;
export const logoutUser                 = impl.logoutUser;
export const sendVerificationEmail      = impl.sendVerificationEmail;
export const markEmailVerified          = impl.markEmailVerified;
export const sendPasswordReset          = impl.sendPasswordReset;
export const attachTenantToCurrentUser  = impl.attachTenantToCurrentUser;
export const updateCurrentUserProfile   = impl.updateCurrentUserProfile;
export const deleteCurrentAccount       = impl.deleteCurrentAccount;
export const slugify                    = impl.slugify;
